import Model from 'flarum/common/Model';
export default class Export extends Model {
  file() {
    return Model.attribute('file').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate);
  }
  destroysAt() {
    return Model.attribute('destroysAt', Model.transformDate);
  }
  user() {
    return Model.hasOne('user');
  }
  actor() {
    return Model.hasOne('actor');
  }
}
flarum.reg.add('flarum-gdpr', 'common/models/Export', Export);